import { FC } from "react";
import { Skeleton, Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";
import { useLocation, useParams } from "react-router-dom";
import { ROUTE_PATHS } from "const/paths";

import RecuringEventForm from "../RecuringEventForm";

import { useRecuringEventDetails } from "./hooks";

const EventDetails: FC = () => {
  const { form, loading } = useRecuringEventDetails();

  const location = useLocation();

  const isRecurringEventDetails = location.pathname.includes(
    ROUTE_PATHS.RecuringEventDetails.replace(":id", "")
  );

  const isRecurringEventCreate = location.pathname.includes(
    ROUTE_PATHS.RecuringEventCreate.replace(":type", "")
  );

  const params = useParams<{ id?: string; type?: string }>();

  const templateId = params.id ? parseInt(params.id, 10) : undefined;

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Recurring event details" />
        </Typography.Title>
      </Header>
      <Space />
      {!loading ? (
        <RecuringEventForm
          isRecurringEventCreate={isRecurringEventCreate}
          isRecurringEventDetails={isRecurringEventDetails}
          templateId={templateId}
          {...form}
        />
      ) : (
        <Skeleton paragraph={{ rows: 10 }} />
      )}
    </>
  );
};

export default EventDetails;
